// ─── TagDropdown — extracted from AdminCCFSLeads.jsx (Phase 1) ───
// Pure prop-driven dropdown with a custom pill-style trigger. Owns its open state only.

import { useState, useEffect, useRef } from 'react';
import { ChevronDown } from 'lucide-react';

export function TagDropdown({ value, options, colorMap, placeholder, onChange, testId }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const color = value ? (colorMap[value] || 'bg-slate-100 text-slate-600 border-slate-200') : 'bg-slate-50 text-slate-400 border-dashed border-slate-300';

  return (
    <div ref={ref} className="relative inline-block">
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
        className={`text-xs font-medium px-2.5 py-1 rounded-full border transition-all hover:shadow-sm ${color}`}
        data-testid={testId}
      >
        {value || placeholder} <ChevronDown className="w-3 h-3 inline ml-0.5 -mt-0.5" />
      </button>
      {open && (
        <div className="absolute top-full mt-1 left-0 z-50 bg-white border border-slate-200 rounded-lg shadow-lg py-1 min-w-[160px]">
          {options.map(opt => (
            <button
              key={opt}
              onClick={(e) => { e.stopPropagation(); onChange(opt); setOpen(false); }}
              className={`w-full text-left text-xs px-3 py-2 hover:bg-slate-50 transition-colors ${opt === value ? 'font-semibold bg-slate-50' : ''}`}
            >
              <span className={`inline-block w-2 h-2 rounded-full mr-2 ${(colorMap[opt] || '').split(' ')[0]}`} />
              {opt}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
